import { render, staticRenderFns } from "./product_taobao.vue?vue&type=template&id=26dfee59&scoped=true&"
import script from "./product_taobao.vue?vue&type=script&lang=js&"
export * from "./product_taobao.vue?vue&type=script&lang=js&"
import style0 from "./product_taobao.vue?vue&type=style&index=0&id=26dfee59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dfee59",
  null
  
)

export default component.exports